import React, { memo } from 'react'

const DatePicker = ({
    text,
    value,
    onChange
}) => {
  return (
    <div>
        <span>{text}:</span>
        <input 
            type="date" 
            style={{width:"100%", maxWidth:"300px", fontSize:"16px"}}
            onChange={onChange}
            value={value.format('YYYY-MM-DD')}
        />
    </div>
  )
}

export default memo(DatePicker)